module.exports = __webpack_public_path__ + "images/sarah-johnson.jpg?v=9e936ef17c7c1053794e77c6de521f45";